export class GoogleSearchService {
  constructor(context) {
    this.context = context;
    this.axios = this.context.$axios;
  }
  async GetGoogleCategoryStats({
    productId,
    subscriberId,
    businessUnitId,
    toDate,
    fromDate,
    bookCode,
    commercialName
  }) {
    try {
      const urlAnalytics = `${process.env.VUE_APP_API_BASE_URL_ANALYTIC}/gsc-siteStats?startDate=${fromDate}&endDate=${toDate}&businessUnit=${businessUnitId}&commercialName=${commercialName}&bookCode=${bookCode}`;
      const categories = await this.axios.get(urlAnalytics);
      productId;
      subscriberId;
      bookCode;
      return categories.data;
    } catch (err) {
      console.log(err);
    }
  }
}
